"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Rx = void 0;
const react_1 = __importStar(require("react"));
const wrapped_1 = require("@rixio/wrapped");
const use_rx_1 = require("./use-rx");
function Rx({ pending, rejected, children, value$ }) {
    const observables = useObservables(value$);
    const [nonce, setNonce] = react_1.useState(0);
    const value = use_rx_1.useRx(observables, [observables, nonce]);
    switch (value.status) {
        case "pending":
            return react_1.default.createElement(react_1.default.Fragment, null, pending);
        case "rejected":
            if (typeof rejected === "function") {
                const reload = () => {
                    value.reload();
                    setNonce(n => n + 1);
                };
                return react_1.default.createElement(react_1.default.Fragment, null, rejected(value.error, reload));
            }
            return react_1.default.createElement(react_1.default.Fragment, null, rejected);
        case "fulfilled":
            const finalResult = Array.isArray(value$) ? value.value : value.value[0];
            if (typeof children === "function") {
                return react_1.default.createElement(react_1.default.Fragment, null, children(finalResult));
            }
            else if (children) {
                return react_1.default.createElement(react_1.default.Fragment, null, children);
            }
            else {
                return react_1.default.createElement(react_1.default.Fragment, null, finalResult);
            }
    }
}
exports.Rx = Rx;
function useObservables(observables) {
    const array = getObservables(observables);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return react_1.useMemo(() => wrapped_1.combineLatest(array), array);
}
function getObservables(observables) {
    if (Array.isArray(observables)) {
        return observables;
    }
    else {
        return [observables];
    }
}
